import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type RootContainerProps } from "@client/content/types";
import { useI18n } from "@common/hooks/i18n";
import { first } from "lodash";
import React from "react";
import Block from "./Block/container";
import SliderWithTitle from "./SliderWithTitle/container";
import { type PackagePricing } from "./types";

export type SlidersValue = {
  contacts: number;
  staff: number;
};

type Props = RootContainerProps & {
  blocksStyle: React.CSSProperties;
  package: PackagePricing.Api.Package;
  tiers: PackagePricing.Api.Tiers;
  trial: PackagePricing.Api.Trial | null;
  style: React.CSSProperties;
};
export default (props: Props) => {
  const i18n = useI18n();

  const [sliders, setSliders] = React.useState<SlidersValue>({
    contacts: first(props.tiers.contacts)?.endValue ?? 1,
    staff: first(props.tiers.staff)?.endValue ?? 1
  });

  const getOnSliderChange = React.useCallback(
    (key: keyof SlidersValue) => (value: number) => {
      setSliders((x) => ({ ...x, [key]: value }));
    },
    []
  );

  return (
    <div className="wsc_content_package_pricing" style={props.style}>
      <ContentTextStyle {...getEntityRef(props)} prefix="price.info" textSubSelector=".block > .price > .info" />
      <ContentTextStyle
        {...getEntityRef(props)}
        prefix="items"
        textSubSelector=".block .items_container > .list-icon-item"
      />

      <div className="sliders_wrap">
        <SliderWithTitle
          {...getRootContainerProps(props)}
          max={100000}
          onChange={getOnSliderChange("contacts")}
          step={1000}
          tiers={props.tiers.contacts}
          title={i18n.infoHowManyContacts}
          value={sliders.contacts}
        />

        <SliderWithTitle
          {...getRootContainerProps(props)}
          max={50}
          onChange={getOnSliderChange("staff")}
          step={1}
          tiers={props.tiers.staff}
          title={i18n.infoHowManyStaff}
          value={sliders.staff}
        />
      </div>
      <div className="blocks_wrap" style={props.blocksStyle}>
        <Block
          {...getRootContainerProps(props)}
          frequency="Month"
          price={props.package.usdMonthPrice}
          sliders={sliders}
          tiers={props.tiers}
        />
        <Block
          {...getRootContainerProps(props)}
          frequency="Quarter"
          price={props.package.usdQuarterPrice}
          sliders={sliders}
          tiers={props.tiers}
        />
        <Block
          {...getRootContainerProps(props)}
          frequency="Year"
          price={props.package.usdYearPrice}
          sliders={sliders}
          tiers={props.tiers}
        />
      </div>
    </div>
  );
};
